export default __webpack_public_path__ + "static/media/KZ.T.06.2204 black.d0c862eb.svg";